import * as React from 'react';
import * as moment from 'moment';
import { RouteComponentProps } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { fetchApi } from '../../services/api';

type Props = RouteComponentProps<{
    childId: string;
}>

type State = {
    notes: NoteData[];
    isLoading: boolean;
    newNote: string;
    childId: number;
}

type NoteData = {
    NoteID: number;
    Text: string;
    Type: number;
    Date: Date;
    CreatedBy: string;
}

export default class Notes extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            notes: [],
            newNote: '',
            childId: 0,
        }

        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestNotes(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.notes && this.state.childId != childId) {
            this.requestNotes(childId);
        }
    }

    public render() {
        return <div>
            <br/>
            {this.state.notes.map((note, index) => {
                return <div className="Card" key={index}>
                    <h5>{moment.utc(note.Date).local().format("YYYY-MM-DD HH:mm")} by {note.CreatedBy || "SYSTEM"}</h5>
                        <div className="card-body">
                            <h6>{note.Text}</h6>
                        </div>
                    </div>
            })}
            <br/>
            <div className="form-group">
                <textarea
                    name="Note"
                    className="form-control"
                    placeholder="New Note..."
                    value={this.state.newNote}
                    onChange={(e) => this.setState({ newNote: e.target.value })}
                />
            </div>
            <Button primary onClick={this.save}>Add Note</Button>
        </div>
    }

    private save(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        if (this.state.newNote) {
            this.setState({ isLoading: true });
            const data = {
                Note: this.state.newNote,
            };
            fetchApi(`api/ChildNotes/Save/${this.state.childId}`, data, 'POST')
            .then((response: { Message: string, Errors: Array<{ Field: string, Message: string }> }) => {
                this.setState({ isLoading: false, newNote: '' });
                this.requestNotes(this.state.childId);
            }).catch((error: Error) => {
                this.setState({ isLoading: false });
                // TODO: Show error
            })
        }
    }

    private requestNotes(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/ChildNotes/List/${childId}`)
            .then((notes: NoteData[]) => {
                this.setState({ isLoading: false, notes });
            });
    }
}
